import { Paths } from "~core/security/auth.roles";

export interface GrupoUsuarioVo {
    id?: string,
    codigoOperacao?: string,
    nome: string,
    descricao:string,
    mapa: MapType,
    painel:PainelType,
    financeiro: FinanceiroType, // pre requisito ativaPrestacaoContas
    torreDeControle: TorreDeControleType,
    administracaoDeVisitas: AdministracaoDeVisitasType,
    importacaoPedidoAvulso: ImportacaoType,
    reprogramacao: ReprogramacaoType,// pre requisito Permite Reprogramação"
    alertaIncidente: AlertaIncidenteType,
    configuracoes: ConfiguracoesType
}

export type MapType = {
    route?: Paths.MAPA,
}

export type PainelType =  {
    route?: Paths.DASHBOARD,
}

export type FinanceiroType={
    route?: Paths.FINANCEIRO,
    visualizacaoRotas: boolean
    visualizarDetalhesDasRotas: boolean,
}

export type TorreDeControleType = {
    route?: Paths.GRID,
    visualizacaoRotas: boolean,
    alteracaoDePedidos: boolean,
    alteracaoDeRotas: boolean,
    visualizarDetalhesDasRotas: boolean,
}

export type AdministracaoDeVisitasType ={
    route?: Paths.ADMIN_VISITAS,
    visualizacaoPedidosOrfaos: boolean,
    insercaoPedidosOrfaos: boolean;
}

export type ImportacaoType = {
    route?: Paths.IMPORTACAO,
}

export type ReprogramacaoType = {
    route?: Paths.REPROGRAMACAO,
    visualizacaoPedidosNaoAtendidos: boolean,
    reprogramacaoPedidos: boolean,
}
export type AlertaIncidenteType = {
    route?: Paths.ALERTAS_INCIDENTES,
    visualizacaoAlertasIncidentes: boolean,
    atendimentoAlertas: boolean,
    registroTratativa: boolean, // pre requisito ativaTratativasIncidentes
}

export type ConfiguracoesType = {
    route?: Paths.CONFIG,
    visualizacaoParametrosSistema: boolean,
    alteracaoParametrosBasicosSistema: boolean,
    alteracaoParametrosAdministrativosSistema: boolean,

    visualizacaoIndicadores: boolean, // adicionar no back-end
    alteracaoIndicadores: boolean,

    visualizacaoDosIncidentes: boolean,
    alteracaoIncidentes: boolean, // adicionar no back-end

    visualizacaoLayoutsImportacao: boolean,
    alteracaoLayoutsImportacao: boolean, // adicionar no back-end

    visualizacaoLayoutsRelatorio: boolean,
    alteracaoLayoutsRelatorio: boolean, // adicionar no back-end

    visualizacaoTiposDespesas: boolean,
    alteracaoTiposDespesas: boolean, // adicionar no back-end

    visualizacaoOcorrenciasSSW: boolean,
    alteracaoOcorrenciasSSW: boolean, // adicionar no back-end

    visualizacaoTratativas: boolean, // pre requisito ativaTratativasIncidentes
    alteracaoTratativas: boolean // pre requisito ativaTratativasIncidentes
}

export const emptyGrupoUsuario = (param:boolean = true): GrupoUsuarioVo => ({
    nome: "",
    descricao: "",
    mapa: emptyMapType(param) ,
    painel: emptyPainelType(param) ,
    importacaoPedidoAvulso: emptyImportacaoType(param) ,
    financeiro: emptyFinanceiroType(param) ,
    torreDeControle: emptyTorreDeControleType(param) ,
    administracaoDeVisitas: emptyAdministracaoDeVisitasType(param) ,
    reprogramacao: emptyReprogramacaoType(param) ,
    alertaIncidente: emptyAlertaIncidenteType(param) ,
    configuracoes: emptyConfiguracoesType(param) ,
});



export const emptyMapType = (_parm: boolean = true): MapType => ({
    route: _parm?Paths.MAPA:undefined,
});

export const emptyPainelType = (_parm: boolean = true): PainelType => ({
    route: _parm?Paths.DASHBOARD:undefined,
});

export const emptyFinanceiroType = (parm: boolean = true): FinanceiroType => ({
    route: parm ? Paths.FINANCEIRO:undefined,
    visualizacaoRotas: parm,
    visualizarDetalhesDasRotas: parm,
});

export const emptyTorreDeControleType = (parm: boolean = true): TorreDeControleType => ({
    route: parm ? Paths.GRID : undefined,
    visualizacaoRotas: parm,
    alteracaoDePedidos: parm,
    alteracaoDeRotas: parm,
    visualizarDetalhesDasRotas: parm,
});

export const emptyAdministracaoDeVisitasType = (parm: boolean = true): AdministracaoDeVisitasType => ({
    route: parm ? Paths.ADMIN_VISITAS : undefined,
    visualizacaoPedidosOrfaos: parm,
    insercaoPedidosOrfaos: parm,
});

export const emptyImportacaoType = (_parm: boolean = true): ImportacaoType => ({
    route: _parm ? Paths.IMPORTACAO : undefined,
});

export const emptyReprogramacaoType = (parm: boolean = true): ReprogramacaoType => ({
    route: parm ? Paths.REPROGRAMACAO: undefined,
    visualizacaoPedidosNaoAtendidos: parm,
    reprogramacaoPedidos: parm,
});

export const emptyAlertaIncidenteType = (parm: boolean = true): AlertaIncidenteType => ({
    route:  parm ? Paths.ALERTAS_INCIDENTES : undefined,
    visualizacaoAlertasIncidentes: parm,
    atendimentoAlertas: parm,
    registroTratativa: parm,
});

export const emptyConfiguracoesType = (parm: boolean = false): ConfiguracoesType => ({
    route: parm ? Paths.CONFIG : undefined,
    visualizacaoParametrosSistema: true,
    alteracaoParametrosBasicosSistema: true,
    alteracaoParametrosAdministrativosSistema: parm,
    visualizacaoIndicadores: true,
    alteracaoIndicadores: true,
    visualizacaoDosIncidentes: true,
    alteracaoIncidentes: true,
    visualizacaoLayoutsImportacao: true,
    visualizacaoLayoutsRelatorio: true,
    visualizacaoTiposDespesas: true,
    visualizacaoOcorrenciasSSW: true,
    visualizacaoTratativas: true,
    alteracaoLayoutsImportacao: parm,
    alteracaoLayoutsRelatorio: parm,
    alteracaoTiposDespesas: parm,
    alteracaoOcorrenciasSSW: parm,
    alteracaoTratativas: parm,
});
